import type { Review } from '@bulknutrients/bulk-shared-lib/interfaces/Review';
import { Container } from '@components/Container';
import { StandardLayout } from '@components/Layouts/StandardLayout';
import { ReviewList } from '@components/Reviews/ReviewList';
import { log } from '@lib/logs/server';
import type { GetServerSideProps } from 'next';
import Head from 'next/head';
import type { ReactElement } from 'react';
import { getReviewsHandler } from './api/reviews';

export default function Reviews({
  reviews,
}: {
  reviews: Review[];
}): ReactElement {
  return (
    <>
      <Head>
        <title>Bulk Nutrients Australia Product and Company Reviews</title>
        <meta
          name="title"
          content="Bulk Nutrients Australia Product and Company Reviews"
        />
        <meta
          name="description"
          content=" Read Bulk Nutrients' customer reviews and discover why we're the go-to source for top-quality supplements in Australia. Then start shopping with us today"
        />
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_SERVER_URL}/reviews`}
        />
      </Head>
      <Container as="main" id="main-content">
        {/* min height required to prevent CLS shift when reviews load */}
        <article className="justify-self-center my-0 min-h-[800px] max-w-narrow-page">
          <h1>Bulk Nutrients Reviews</h1>
          <ReviewList initReviews={reviews} />
        </article>
      </Container>
    </>
  );
}

Reviews.getLayout = function getLayout(page: ReactElement) {
  return <StandardLayout>{page}</StandardLayout>;
};

export const getServerSideProps: GetServerSideProps = async () => {
  try {
    const reviews: Review[] = await getReviewsHandler({
      pageSize: 10,
      page: 0,
      status: 'approved',
    });
    return {
      props: {
        reviews,
      },
    };
  } catch (error) {
    log({
      error,
      location: 'getServerSideProps /reviews',
    });
    throw error;
  }
};
